import { Footer } from './components/layout/Footer';
import { MobileStickyCta } from './components/layout/MobileStickyCta';
import { Navbar } from './components/layout/Navbar';
import { FeaturesSection } from './components/sections/FeaturesSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { HeroSection } from './components/sections/HeroSection';
import { InstitutionsSection } from './components/sections/InstitutionsSection';
import { PricingSection } from './components/sections/PricingSection';
import { TrustSection } from './components/sections/TrustSection';

function App() {
  return (
    <div className="min-h-screen bg-white pb-20 sm:pb-0">
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <FeaturesSection />
        <InstitutionsSection />
        <PricingSection />
        <FinalCtaSection />
      </main>
      <Footer />
      <MobileStickyCta />
    </div>
  );
}

export default App;
